// Subscribable store — minimal pubsub layered over the existing `state` object.
// Phase 2 of the migration: gives Preact components (Phase 3+) a way to react
// to state changes without rewiring every call site at once.
//
// Usage:
//   import { subscribe, notifyChange } from './store.js';
//   const off = subscribe(() => repaintMyComponent());  // returns unsubscribe
//   ...later...
//   notifyChange();   // batched; multiple sync calls coalesce to one fire
//
// notifyChange() is auto-fired from state.js#save(), so most mutation paths
// already trigger subscribers without per-callsite changes. Tick-only
// mutations (state.count += rate per second) don't go through save() —
// the tick loop calls notifyChange() directly.
const subs = new Set();
let scheduled = false;

export function subscribe(fn) {
  subs.add(fn);
  return () => subs.delete(fn);
}

export function notifyChange() {
  if (scheduled) return;
  scheduled = true;
  queueMicrotask(() => {
    scheduled = false;
    for (const fn of subs) {
      try { fn(); } catch (e) { console.error('store subscriber threw:', e); }
    }
  });
}

// Test/diagnostic only — not for production use. Useful in unit tests to
// flush + count fires synchronously.
export function _subscriberCount() { return subs.size; }
